import { Component, OnInit } from '@angular/core';
import { WarehouseService } from '../../_services/warehouse.service';

import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
declare var jQuery: any;
import '../../../assets/semantic/semantic.min.js';

import { SecurityService } from '../../_services/security.service';
@Component({
  selector: 'app-warehouse',
  templateUrl: './warehouse.component.html',
  styleUrls: ['./warehouse.component.css']
})
export class WarehouseComponent implements OnInit {
  
  private page_param: string;
  private warehouses_count: number;
  private page_number: number;
  private page_count: number;
  private page_indicators: number[];
  
  private warehouses: object[];

  constructor(private securityService: SecurityService, private warehouseService: WarehouseService, private route: ActivatedRoute, private router: Router) { }

  filters = new FormGroup({
    name: new FormControl(''),
  });

  ngOnInit() { 
    // Get the Params..
    this.route.queryParams.subscribe(params => {
      this.page_param = params['page'] || 1; // Get Page number Param
    });

    this.filters.valueChanges.debounceTime(500).subscribe(
      (value) => {
        this.router.navigate(['/warehouses'], { queryParams: { page: '1' } })
        this.refresh();
      }
    )

    this.refresh();
  }

  refresh() {
    let params = {};
    Object.assign(params, this.filters.value, { page: this.page_param });
    Object.assign(params, { full: false });
    this.warehouseService.getWarehouses(params) // Get warehouses List
      .subscribe(response => {
        this.warehouses = response.warehouses;                      // Cities Page List
        this.warehouses_count = parseInt(response.total_count);   // Cities Count
        this.page_number = parseInt(response.page);              // Current Page
        this.page_count = Math.ceil(this.warehouses_count / 25);   // Page Count
        // Page Indicators (for ngFor iterations)
        if (this.page_count < 10) {
          this.page_indicators = Array(this.page_count).fill(1);
        } else {
          this.page_indicators = Array(10).fill(1);
        }
      });
  }
  // Previous Page Button
  previousPage() {
    this.router.navigate(['/warehouses'], { queryParams: { page: this.page_number - 1 } }).then(function () {
      this.refresh();
    }.bind(this));
  }

  // Next Page Button
  nextPage() {
    this.router.navigate(['/warehouses'], { queryParams: { page: this.page_number + 1 } }).then(function () {
      this.refresh();
    }.bind(this));
  }

  // Go to page n°nb
  toPage(nb: number) {
    this.router.navigate(['/warehouses'], { queryParams: { page: nb } }).then(function () {
      this.refresh();
    }.bind(this));
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/warehouse/warehouse.component.ts